export default __webpack_public_path__ + "images/b2479ab5f906db4f0b45996211d49776.png";